/*
 * Entro Bulk Ordering (replaces SparkLayer storefront features) - Oct 2026
 * - Bulk +/- variant table on product pages and in the collection "Choose options" popup
 * - Cart line cap guard (blocks any add that would push the cart over the cap)
 * - Quick Order by SKU / UPC (with barcode scanning, see sections/entro-quick-order.liquid)
 * - Reorder a past order (buttons on the account orders table)
 * Config: window.EntroBulkConfig = { lineCap: 150 } (set in snippets/entro-bulk-assets.liquid)
 */
(function () {
  if (window.EntroBulk) return;

  var CFG = Object.assign({ lineCap: 150, chunk: 100 }, window.EntroBulkConfig || {});
  var nativeFetch = window.fetch.bind(window);
  var BULK_HEADER = 'X-Entro-Bulk';

  /* ---------- helpers ---------- */
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function getCart() {
    return nativeFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refreshThemeCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }
  function openThemeCart() {
    var t = document.querySelector('.header__cart-toggle[data-action="toggle-mini-cart"]');
    if (t) { t.click(); } else { window.location.href = '/cart'; }
  }

  /* ---------- simple notice dialog ---------- */
  function notice(title, html, actions) {
    var wrap = document.createElement('div');
    wrap.className = 'eb-notice';
    wrap.setAttribute('role', 'alertdialog');
    wrap.setAttribute('aria-modal', 'true');
    var btns = (actions || [{ label: 'OK', primary: true }]).map(function (a, i) {
      return '<button type="button" class="button ' + (a.primary ? 'button--primary' : 'button--secondary') + '" data-i="' + i + '">' + esc(a.label) + '</button>';
    }).join('');
    wrap.innerHTML = '<div class="eb-notice__box"><p class="eb-notice__title">' + esc(title) + '</p><div class="eb-notice__body">' + html + '</div><div class="eb-notice__actions">' + btns + '</div></div>';
    document.body.appendChild(wrap);
    var first = wrap.querySelector('button');
    if (first) first.focus();
    function close() { wrap.remove(); }
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-i]');
      if (b) {
        var a = (actions || [])[Number(b.getAttribute('data-i'))];
        close();
        if (a && a.onClick) a.onClick();
      } else if (e.target === wrap) { close(); }
    });
    wrap.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- cart line cap ---------- */
  function checkCap(items) {
    return getCart().then(function (cart) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.variant_id] = true; });
      var seen = {}, newLines = 0;
      items.forEach(function (it) {
        var id = Number(it.id);
        if (!inCart[id] && !seen[id]) { newLines++; seen[id] = true; }
      });
      return { ok: cart.items.length + newLines <= CFG.lineCap, lines: cart.items.length, newLines: newLines, cart: cart };
    });
  }
  function capText(res) {
    return 'Your cart has ' + res.lines + ' of ' + CFG.lineCap + ' items (product lines) allowed per order. This would add ' + res.newLines + ' more, which is over the limit. Please check out this order first, then start a new order for the rest.';
  }
  function showCap(res) {
    notice('Your cart is full for one order', '<p>' + esc(capText(res)) + '</p>', [
      { label: 'Check out now', primary: true, onClick: function () { window.location.href = '/checkout'; } },
      { label: 'Keep browsing' }
    ]);
  }

  /* Global guard: catches every /cart/add made by the theme or apps via fetch */
  function parseAddBody(init) {
    try {
      var body = init && init.body;
      if (!body) return null;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var id = body.get('id');
        return id ? [{ id: id, quantity: Number(body.get('quantity') || 1) }] : null;
      }
      if (typeof body === 'string') {
        var j = JSON.parse(body);
        if (j.items) return j.items;
        if (j.id) return [{ id: j.id, quantity: j.quantity || 1 }];
      }
    } catch (e) {}
    return null;
  }
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var h = init && init.headers;
      var ours = h && (h[BULK_HEADER] || (typeof h.get === 'function' && h.get(BULK_HEADER)));
      if (!ours && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        var items = parseAddBody(init);
        if (items && items.length) {
          return checkCap(items).then(function (res) {
            if (res.ok) return nativeFetch(input, init);
            showCap(res);
            return new Response(JSON.stringify({ status: 422, message: 'Cart limit reached', description: capText(res) }), { status: 422, headers: { 'Content-Type': 'application/json' } });
          }, function () { return nativeFetch(input, init); });
        }
      }
    } catch (e) {}
    return nativeFetch(input, init);
  };

  /* ---------- add items (chunked, with per-item fallback) ---------- */
  function postAdd(items) {
    return nativeFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Entro-Bulk': '1' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, data: j }; });
    });
  }
  function addItems(items) {
    items = items.filter(function (i) { return Number(i.quantity) > 0; }).map(function (i) { return { id: Number(i.id), quantity: Number(i.quantity) }; });
    if (!items.length) return Promise.resolve({ added: [], skipped: [] });
    return checkCap(items).then(function (res) {
      if (!res.ok) { showCap(res); return Promise.reject({ capped: true }); }
      var chunks = [];
      for (var i = 0; i < items.length; i += CFG.chunk) chunks.push(items.slice(i, i + CFG.chunk));
      var added = [], skipped = [];
      return chunks.reduce(function (p, chunk) {
        return p.then(function () {
          return postAdd(chunk).then(function (r) {
            if (r.ok) { added = added.concat(chunk); return; }
            /* One bad line fails the whole batch: retry one by one */
            return chunk.reduce(function (pp, it) {
              return pp.then(function () {
                return postAdd([it]).then(function (r1) {
                  if (r1.ok) added.push(it);
                  else skipped.push({ item: it, reason: (r1.data && (r1.data.description || r1.data.message)) || 'Could not be added' });
                });
              });
            }, Promise.resolve());
          });
        });
      }, Promise.resolve()).then(function () {
        refreshThemeCart();
        return { added: added, skipped: skipped };
      });
    });
  }

  function resultHtml(res, nameOf) {
    var units = res.added.reduce(function (s, i) { return s + i.quantity; }, 0);
    var html = '';
    if (res.added.length) {
      html += '<p class="eb-ok">Added ' + units + ' unit' + (units === 1 ? '' : 's') + ' (' + res.added.length + ' item' + (res.added.length === 1 ? '' : 's') + ') to your cart. <button type="button" class="link eb-viewcart">View cart</button></p>';
    }
    if (res.skipped.length) {
      html += '<p class="eb-err">Not added:</p><ul class="eb-err">' + res.skipped.map(function (s) {
        return '<li>' + esc(nameOf ? nameOf(s.item.id) : s.item.id) + ': ' + esc(s.reason) + '</li>';
      }).join('') + '</ul>';
    }
    return html;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.eb-viewcart')) {
      var m = document.querySelector('.eb-modal');
      if (m) closeModal();
      openThemeCart();
    }
  });

  function cartInfo(el) {
    if (!el) return;
    getCart().then(function (c) {
      var n = c.items.length;
      el.textContent = 'Cart: ' + n + ' of ' + CFG.lineCap + ' items per order';
      el.classList.toggle('eb-warn', n >= CFG.lineCap * 0.9);
    }).catch(function () {});
  }

  /* ---------- bulk variant table ---------- */
  function variantName(p, v) {
    if (!v.title || v.title === 'Default Title') return p.title;
    return v.options && v.options.length ? v.options.join(' / ') : v.title;
  }
  function stockLabel(v) {
    if (!v.available) return '<span class="eb-stock eb-stock--out">Out of stock</span>';
    if (v.stock != null && v.stock <= 10) return '<span class="eb-stock eb-stock--low">Only ' + v.stock + ' left</span>';
    return '<span class="eb-stock eb-stock--in">In stock</span>';
  }

  function renderTable(root, p) {
    var vs = p.variants || [];
    var hasSku = vs.some(function (v) { return v.sku; });
    var hasUpc = vs.some(function (v) { return v.barcode; });
    var rows = vs.map(function (v) {
      var name = variantName(p, v);
      var img = v.image || p.image;
      var max = v.stock != null ? v.stock : '';
      var search = (name + ' ' + (v.sku || '') + ' ' + (v.barcode || '')).toLowerCase();
      return '<tr class="eb-row' + (v.available ? '' : ' eb-row--out') + '" data-id="' + v.id + '" data-price="' + v.price + '" data-search="' + esc(search) + '">' +
        '<td class="eb-c-variant">' + (img ? '<img src="' + esc(img) + '" alt="" width="40" height="40" loading="lazy">' : '') + '<span class="eb-name">' + esc(name) + '</span></td>' +
        (hasSku ? '<td class="eb-c-sku"><span class="eb-lbl">SKU</span>' + esc(v.sku || '-') + '</td>' : '') +
        (hasUpc ? '<td class="eb-c-upc"><span class="eb-lbl">UPC</span>' + esc(v.barcode || '-') + '</td>' : '') +
        '<td class="eb-c-price">' + money(v.price) + (v.compare > v.price ? ' <s>' + money(v.compare) + '</s>' : '') + '</td>' +
        '<td class="eb-c-stock">' + stockLabel(v) + '</td>' +
        '<td class="eb-c-qty"><div class="eb-qty">' +
          '<button type="button" class="eb-minus" aria-label="Decrease quantity for ' + esc(name) + '"' + (v.available ? '' : ' disabled') + '>&minus;</button>' +
          '<input type="number" inputmode="numeric" min="0" step="1" value="0"' + (max !== '' ? ' max="' + max + '"' : '') + ' aria-label="Quantity for ' + esc(name) + '"' + (v.available ? '' : ' disabled') + '>' +
          '<button type="button" class="eb-plus" aria-label="Increase quantity for ' + esc(name) + '"' + (v.available ? '' : ' disabled') + '>+</button>' +
        '</div></td></tr>';
    }).join('');

    root.innerHTML =
      '<div class="eb">' +
        (vs.length > 8 ? '<div class="eb-filter"><input type="search" placeholder="Filter by model, color, SKU or UPC" aria-label="Filter variants"></div>' : '') +
        '<div class="eb-scroll"><table class="eb-table"><thead><tr><th>' + (vs.length > 1 ? 'Variant' : 'Product') + '</th>' + (hasSku ? '<th>SKU</th>' : '') + (hasUpc ? '<th>UPC</th>' : '') + '<th>Price</th><th>Stock</th><th>Qty</th></tr></thead><tbody>' + rows + '</tbody></table></div>' +
        '<div class="eb-footer"><div class="eb-summary"><strong class="eb-total">0 units &middot; $0.00</strong><span class="eb-cartinfo"></span></div>' +
        '<div class="eb-actions"><button type="button" class="button button--secondary eb-clear" disabled>Clear</button><button type="button" class="button button--primary eb-add" disabled>Add to cart</button></div></div>' +
        '<div class="eb-msg" role="status" aria-live="polite"></div>' +
      '</div>';

    var names = {};
    vs.forEach(function (v) { names[v.id] = variantName(p, v); });
    var tbody = root.querySelector('tbody');
    var totalEl = root.querySelector('.eb-total');
    var addBtn = root.querySelector('.eb-add');
    var clearBtn = root.querySelector('.eb-clear');
    var msg = root.querySelector('.eb-msg');
    cartInfo(root.querySelector('.eb-cartinfo'));

    function clamp(input) {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 0) v = 0;
      var max = input.getAttribute('max');
      if (max !== null && max !== '' && v > Number(max)) v = Number(max);
      input.value = v;
      input.closest('tr').classList.toggle('eb-row--picked', v > 0);
    }
    function update() {
      var units = 0, cents = 0, lines = 0;
      tbody.querySelectorAll('tr').forEach(function (tr) {
        var q = parseInt(tr.querySelector('input').value, 10) || 0;
        if (q > 0) { units += q; lines++; cents += q * Number(tr.getAttribute('data-price')); }
      });
      totalEl.innerHTML = units + ' unit' + (units === 1 ? '' : 's') + (lines > 1 ? ' (' + lines + ' items)' : '') + ' &middot; ' + money(cents);
      addBtn.disabled = units === 0;
      clearBtn.disabled = units === 0;
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('.eb-minus, .eb-plus');
      if (b) {
        var input = b.parentNode.querySelector('input');
        input.value = (parseInt(input.value, 10) || 0) + (b.classList.contains('eb-plus') ? 1 : -1);
        clamp(input); update();
      }
    });
    root.addEventListener('input', function (e) {
      if (e.target.matches('.eb-qty input')) { update(); }
      if (e.target.matches('.eb-filter input')) {
        var q = e.target.value.trim().toLowerCase();
        tbody.querySelectorAll('tr').forEach(function (tr) {
          tr.hidden = q && tr.getAttribute('data-search').indexOf(q) === -1;
        });
      }
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('.eb-qty input')) { clamp(e.target); update(); }
    });
    root.addEventListener('keydown', function (e) {
      if (e.target.matches('.eb-qty input') && e.key === 'Enter') { e.preventDefault(); clamp(e.target); update(); }
    });
    clearBtn.addEventListener('click', function () {
      tbody.querySelectorAll('input').forEach(function (i) { i.value = 0; clamp(i); });
      update(); msg.innerHTML = '';
    });
    addBtn.addEventListener('click', function () {
      var items = [];
      tbody.querySelectorAll('tr').forEach(function (tr) {
        var q = parseInt(tr.querySelector('input').value, 10) || 0;
        if (q > 0) items.push({ id: tr.getAttribute('data-id'), quantity: q });
      });
      if (!items.length) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
      msg.innerHTML = '';
      addItems(items).then(function (res) {
        msg.innerHTML = resultHtml(res, function (id) { return names[id]; });
        var addedIds = {};
        res.added.forEach(function (i) { addedIds[i.id] = true; });
        tbody.querySelectorAll('tr').forEach(function (tr) {
          if (addedIds[Number(tr.getAttribute('data-id'))]) { var inp = tr.querySelector('input'); inp.value = 0; clamp(inp); }
        });
        cartInfo(root.querySelector('.eb-cartinfo'));
      }, function (err) {
        if (!err || !err.capped) msg.innerHTML = '<p class="eb-err">Something went wrong adding to your cart. Please try again.</p>';
      }).then(function () {
        addBtn.textContent = 'Add to cart';
        update();
      });
    });
    update();
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-entro-bulk]:not([data-eb-ready])').forEach(function (el) {
      el.setAttribute('data-eb-ready', '1');
      var json = el.querySelector('script[type="application/json"]');
      if (!json) return;
      try { var data = JSON.parse(json.textContent); var mount = document.createElement('div'); el.appendChild(mount); renderTable(mount, data); } catch (e) { console.error('Entro bulk table', e); }
    });
    (scope || document).querySelectorAll('[data-entro-quick-order]:not([data-eb-ready])').forEach(initQuickOrder);
    (scope || document).querySelectorAll('[data-entro-reorder-list]:not([data-eb-ready])').forEach(initReorder);
  }

  /* ---------- "Choose options" popup on collection / search ---------- */
  var lastOpener = null;
  function closeModal() {
    var m = document.querySelector('.eb-modal');
    if (!m) return;
    m.remove();
    document.documentElement.classList.remove('eb-lock');
    if (lastOpener) { try { lastOpener.focus(); } catch (e) {} }
  }
  function openModal(url, title) {
    closeModal();
    var base = url.split('#')[0].split('?')[0];
    var m = document.createElement('div');
    m.className = 'eb-modal';
    m.innerHTML = '<div class="eb-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="eb-modal-title">' +
      '<div class="eb-modal__head"><div><p id="eb-modal-title" class="eb-modal__title">' + esc(title || 'Choose options') + '</p><a class="link eb-modal__pdp" href="' + esc(base) + '">View full product page</a></div>' +
      '<button type="button" class="eb-modal__close" aria-label="Close">&times;</button></div>' +
      '<div class="eb-modal__body"><p class="eb-loading">Loading options...</p></div></div>';
    document.body.appendChild(m);
    document.documentElement.classList.add('eb-lock');
    m.querySelector('.eb-modal__close').focus();
    m.addEventListener('click', function (e) {
      if (e.target === m || e.target.closest('.eb-modal__close')) closeModal();
    });
    nativeFetch(base + '?view=bulk-json', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var data = JSON.parse(t);
        m.querySelector('#eb-modal-title').textContent = data.title;
        renderTable(m.querySelector('.eb-modal__body'), data);
      })
      .catch(function () {
        m.querySelector('.eb-modal__body').innerHTML = '<p class="eb-err">Could not load options. <a class="link" href="' + esc(base) + '">Open the product page</a>.</p>';
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-entro-bulk-open]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    lastOpener = b;
    openModal(b.getAttribute('data-url') || b.getAttribute('href'), b.getAttribute('data-title'));
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.querySelector('.eb-modal') && !document.querySelector('.eb-notice')) closeModal(); });

  /* ---------- Quick Order by SKU / UPC ---------- */
  function lookup(terms) {
    /* One storefront search per SKU / UPC (OR-queries and quoted terms are unreliable in Shopify search),
       4 at a time, then an exact match on the variant's SKU or barcode. Uses templates/search.bulk-json.liquid. */
    var map = {};
    var uniq = [];
    terms.forEach(function (t) { var k = String(t || '').trim(); if (k && uniq.indexOf(k) === -1) uniq.push(k); });
    var i = 0;
    function worker() {
      if (i >= uniq.length) return Promise.resolve();
      var term = uniq[i++];
      var clean = term.replace(/["()]/g, '');
      return nativeFetch('/search?type=product&view=bulk-json&q=' + encodeURIComponent(clean), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var data = JSON.parse(t), k = term.toLowerCase();
          (data.results || []).forEach(function (p) {
            (p.variants || []).forEach(function (v) {
              if ((v.sku || '').toLowerCase() === k || (v.barcode || '').toLowerCase() === k) map[k] = { product: p, variant: v };
            });
          });
        })
        .catch(function () {})
        .then(worker);
    }
    var workers = [];
    for (var w = 0; w < Math.min(4, uniq.length); w++) workers.push(worker());
    return Promise.all(workers).then(function () { return map; });
  }

  function initQuickOrder(el) {
    el.setAttribute('data-eb-ready', '1');
    el.innerHTML =
      '<div class="eb eb-qo">' +
        '<div class="eb-qo__paste"><label for="eb-qo-paste"><strong>Paste your list</strong> &mdash; one SKU or UPC per line, followed by a quantity (e.g. <code>ENX-IP17-CLR, 24</code>)</label>' +
        '<textarea id="eb-qo-paste" rows="5" placeholder="SKU or UPC, quantity"></textarea>' +
        '<button type="button" class="button button--secondary eb-qo__load">Add list to order form</button></div>' +
        '<div class="eb-scroll"><table class="eb-table eb-qo__table"><thead><tr><th>SKU or UPC</th><th>Product</th><th>Price</th><th>Stock</th><th>Qty</th><th><span class="visually-hidden">Remove</span></th></tr></thead><tbody></tbody></table></div>' +
        '<div class="eb-qo__more"><button type="button" class="link eb-qo__addrow">+ Add another line</button></div>' +
        '<div class="eb-footer"><div class="eb-summary"><strong class="eb-total">0 units &middot; $0.00</strong><span class="eb-cartinfo"></span></div>' +
        '<div class="eb-actions"><button type="button" class="button button--secondary eb-clear">Clear</button><button type="button" class="button button--primary eb-add" disabled>Add all to cart</button></div></div>' +
        '<div class="eb-msg" role="status" aria-live="polite"></div>' +
      '</div>';
    var tbody = el.querySelector('tbody');
    var totalEl = el.querySelector('.eb-total');
    var addBtn = el.querySelector('.eb-add');
    var msg = el.querySelector('.eb-msg');
    cartInfo(el.querySelector('.eb-cartinfo'));

    function addRow(term, qty) {
      var tr = document.createElement('tr');
      tr.className = 'eb-row';
      tr.innerHTML = '<td class="eb-c-sku"><input type="text" class="eb-qo__term" placeholder="SKU or UPC" aria-label="SKU or UPC" value="' + esc(term || '') + '"></td>' +
        '<td class="eb-c-variant eb-qo__found"><span class="eb-muted">&mdash;</span></td><td class="eb-c-price"></td><td class="eb-c-stock"></td>' +
        '<td class="eb-c-qty"><div class="eb-qty"><button type="button" class="eb-minus" aria-label="Decrease">&minus;</button><input type="number" inputmode="numeric" min="0" step="1" value="' + (qty || 1) + '" aria-label="Quantity"><button type="button" class="eb-plus" aria-label="Increase">+</button></div></td>' +
        '<td><button type="button" class="eb-qo__remove" aria-label="Remove line">&times;</button></td>';
      tbody.appendChild(tr);
      return tr;
    }
    function resolveRows(rows) {
      var terms = [];
      rows.forEach(function (tr) {
        var t = tr.querySelector('.eb-qo__term').value.trim();
        tr.removeAttribute('data-id');
        if (t) { terms.push(t); tr.querySelector('.eb-qo__found').innerHTML = '<span class="eb-muted">Looking up...</span>'; }
      });
      if (!terms.length) { update(); return; }
      lookup(terms).then(function (map) {
        rows.forEach(function (tr) {
          var t = tr.querySelector('.eb-qo__term').value.trim();
          if (!t) return;
          var hit = map[t.toLowerCase()];
          var found = tr.querySelector('.eb-qo__found');
          if (!hit) {
            found.innerHTML = '<span class="eb-err">Not found</span>';
            tr.querySelector('.eb-c-price').innerHTML = '';
            tr.querySelector('.eb-c-stock').innerHTML = '';
            return;
          }
          var v = hit.variant, p = hit.product;
          tr.setAttribute('data-id', v.id);
          tr.setAttribute('data-price', v.price);
          tr.classList.toggle('eb-row--out', !v.available);
          found.innerHTML = '<a class="link" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(p.title) + '</a>' + (v.title && v.title !== 'Default Title' ? '<span class="eb-muted"> &middot; ' + esc(variantName(p, v)) + '</span>' : '');
          tr.querySelector('.eb-c-price').innerHTML = money(v.price);
          tr.querySelector('.eb-c-stock').innerHTML = stockLabel(v);
          var input = tr.querySelector('.eb-qty input');
          if (v.stock != null) {
            input.setAttribute('max', v.stock);
            if ((parseInt(input.value, 10) || 0) > v.stock) input.value = v.stock;
          } else input.removeAttribute('max');
        });
        update();
      });
    }
    function update() {
      var units = 0, cents = 0, ready = 0;
      tbody.querySelectorAll('tr').forEach(function (tr) {
        var q = parseInt(tr.querySelector('.eb-qty input').value, 10) || 0;
        if (tr.getAttribute('data-id') && q > 0 && !tr.classList.contains('eb-row--out')) { units += q; ready++; cents += q * Number(tr.getAttribute('data-price')); }
      });
      totalEl.innerHTML = units + ' unit' + (units === 1 ? '' : 's') + ' (' + ready + ' item' + (ready === 1 ? '' : 's') + ') &middot; ' + money(cents);
      addBtn.disabled = units === 0;
    }
    for (var i = 0; i < 5; i++) addRow('', 1);

    el.addEventListener('click', function (e) {
      var b = e.target.closest('.eb-minus, .eb-plus');
      if (b) {
        var input = b.parentNode.querySelector('input');
        var v = (parseInt(input.value, 10) || 0) + (b.classList.contains('eb-plus') ? 1 : -1);
        var max = input.getAttribute('max');
        if (v < 0) v = 0;
        if (max !== null && max !== '' && v > Number(max)) v = Number(max);
        input.value = v; update();
      }
      if (e.target.closest('.eb-qo__remove')) { e.target.closest('tr').remove(); update(); }
      if (e.target.closest('.eb-qo__addrow')) { addRow('', 1).querySelector('input').focus(); }
      if (e.target.closest('.eb-qo__load')) {
        var ta = el.querySelector('#eb-qo-paste');
        var lines = ta.value.split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
        if (!lines.length) return;
        tbody.querySelectorAll('tr').forEach(function (tr) { if (!tr.querySelector('.eb-qo__term').value.trim()) tr.remove(); });
        var newRows = lines.map(function (l) {
          var parts = l.split(/[\t,;]+|\s{2,}|\s+(?=\d+$)/).map(function (s) { return s.trim(); }).filter(Boolean);
          var term = parts[0];
          var qty = parseInt(parts[1], 10);
          return addRow(term, isNaN(qty) ? 1 : qty);
        });
        ta.value = '';
        resolveRows(newRows);
      }
      if (e.target.closest('.eb-clear')) {
        tbody.innerHTML = '';
        for (var k = 0; k < 5; k++) addRow('', 1);
        msg.innerHTML = '';
        update();
      }
    });
    el.addEventListener('change', function (e) {
      if (e.target.matches('.eb-qo__term')) resolveRows([e.target.closest('tr')]);
      if (e.target.matches('.eb-qty input')) update();
    });
    el.addEventListener('input', function (e) { if (e.target.matches('.eb-qty input')) update(); });
    el.addEventListener('keydown', function (e) {
      if (e.target.matches('.eb-qo__term') && e.key === 'Enter') {
        e.preventDefault();
        resolveRows([e.target.closest('tr')]);
        var next = e.target.closest('tr').nextElementSibling || addRow('', 1);
        next.querySelector('.eb-qo__term').focus();
      }
    });
    addBtn.addEventListener('click', function () {
      var items = [], names = {};
      tbody.querySelectorAll('tr').forEach(function (tr) {
        var id = tr.getAttribute('data-id');
        var q = parseInt(tr.querySelector('.eb-qty input').value, 10) || 0;
        if (id && q > 0 && !tr.classList.contains('eb-row--out')) {
          items.push({ id: id, quantity: q });
          names[id] = tr.querySelector('.eb-qo__term').value.trim();
        }
      });
      if (!items.length) return;
      addBtn.disabled = true; addBtn.textContent = 'Adding...'; msg.innerHTML = '';
      addItems(items).then(function (res) {
        msg.innerHTML = resultHtml(res, function (id) { return names[id]; });
        cartInfo(el.querySelector('.eb-cartinfo'));
      }, function (err) {
        if (!err || !err.capped) msg.innerHTML = '<p class="eb-err">Something went wrong adding to your cart. Please try again.</p>';
      }).then(function () { addBtn.textContent = 'Add all to cart'; update(); });
    });
  }

  /* ---------- Reorder a past order (account orders table) ---------- */
  function initReorder(el) {
    el.setAttribute('data-eb-ready', '1');
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-entro-reorder]');
      if (!b) return;
      var items;
      try { items = JSON.parse(b.getAttribute('data-entro-reorder')); } catch (x) { return; }
      var host = b.closest('.eb-ro__order');
      var out = host && host.querySelector('.eb-msg');
      b.disabled = true; var label = b.textContent; b.textContent = 'Adding...';
      var names = {};
      items.forEach(function (i) { names[i.id] = i.name; });
      addItems(items).then(function (res) {
        if (out) out.innerHTML = resultHtml(res, function (id) { return names[id]; });
      }, function (err) {
        if (out && (!err || !err.capped)) out.innerHTML = '<p class="eb-err">Something went wrong. Please try again.</p>';
      }).then(function () { b.disabled = false; b.textContent = label; });
    });
  }

  window.EntroBulk = { addItems: addItems, open: openModal, close: closeModal, scan: scan, config: CFG, nativeFetch: nativeFetch };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  /* Catch content the theme injects later (quick view, filters, infinite scroll) */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { scan(); break; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
